// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"835":"8058f7a8","943":"f36e90ea"}[chunkId] + ".chunk.js";
};